import http from '@/utils/http' //引入axios
export const getDidiTransaction = data => http.get('/kg-payment/api/dof/transaction', {
    params: data
}) //查找Didi交易记录
export const exportCord = data => http.get('/kg-payment/api/dof/transaction/excel', {
    params: data,
    responseType: 'blob'
})
export default {
    getDidiTransaction,
    exportCord
}